import React, { Component } from "react";
import { connect } from "react-redux";
import { planSizeChange } from "../../../common/actions";
import { SIGNUP_URL_TIER1, SIGNUP_URL_PROD } from "../../../common/constants";
import { loadRateCards } from "../../../Containers/Pricing/actions";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { numberWithCommas } from "../../../utility/commonHelpers";
const mapStateToProps = (state) => ({
  subscribePlanInfo: state.subscribePlanInfo,
});

class SubscriptionPlansPreLogin extends Component {
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.register = this.register.bind(this);
    this.state = {height:window.innerHeight, width:window.innerWidth}
  }
  handleResize = () => {
    const {innerHeight:height, innerWidth:width} = window
    this.setState({height,width})
  } 
  componentDidMount() {
    window.addEventListener("resize", this.handleResize)
    if (this.props.subscribePlanInfo.ratecardList.PlanSizes == null) this.props.dispatch(loadRateCards());
  }
  componentWillUnmount(){
    window.removeEventListener("resize", this.handleResize)
  }
  handleOnChange = (event) => {
    if (event != undefined && parseInt(event) >= 0) {
      this.props.dispatch(
        planSizeChange({
          size: this.props.subscribePlanInfo.ratecardList.PlanSizes[event],
          ratecardList: this.props.subscribePlanInfo.ratecardList,
        })
      );
    }
  };
  register(e) {
    e.preventDefault();
    if (process.env.REACT_APP_ENV == "production") {
      window.parent.location.href = SIGNUP_URL_PROD;
    } else {
      window.parent.location.href = SIGNUP_URL_TIER1;
    }
  }
  calculateRate(DiscountedPrice, Freequency) {
    return parseInt(DiscountedPrice) / parseInt(Freequency);
  }
  calculateSliderValue(value) {
    let retVal;
    if(parseInt(value) >= 1000000) retVal = parseInt(value) / parseInt(1000000) + "M"
    else if (parseInt(value) >= 1000) retVal = parseInt(value) / parseInt(1000) + "k";
    else retVal = value;
    return retVal;
  }
  calculateDisplayValue(value){
    let retVal;
    if(parseInt(value) >= 1000000) retVal = parseInt(value) / parseInt(1000000) + "Million"
    else retVal = numberWithCommas(value);
    return retVal;
  }
  render() {
    const ratecards = this.props.subscribePlanInfo.eligibleRateCards;
    const marksList = this.props.subscribePlanInfo.ratecardList.PlanSizes;
    let plns = this.props.subscribePlanInfo.ratecardList.Plans
    let disc = (plns && plns[this.props.subscribePlanInfo.currentValue] || {}).PlanDiscount
    let maxSize = 1000;
    let minSize = 1000;
    let marks = {}, emptyIndexes = {};
    if (marksList) {
      let keys = Object.keys(marksList)
      minSize = parseInt(keys[0]);
      maxSize = parseInt(keys[keys.length - 1]);
      const allPlans = this.props.subscribePlanInfo.ratecardList.Plans;
      // for (const mark of marksList) {
      marksList.forEach((mark, index) => {
        let planDiscount = 0;
        if (allPlans) planDiscount = allPlans[mark].PlanDiscount;
        const marklabel = {
          label: (
            <div>
              {this.calculateSliderValue(mark)}
              {planDiscount == 0 ? (
                ""
              ) : (
                <span className="sliderPercentage" title="discount">
                  ({planDiscount.toFixed(1)}%)
                </span>
              )}
            </div>
          ),
        };
        const emptyLabel = {
          label: (
            <div>
              {(index == 0 || index+1 == marksList.length) ? this.calculateSliderValue(mark) : ""}
            </div>
          ),
        }
        marks = { ...marks, [index]: marklabel };
        emptyIndexes = { ...emptyIndexes, [index]: emptyLabel }
      // }
      })
    }
    return (
      <div
        className="row row-flex pricingPage pricing-expert full-height subscription-plans"
        style={{ marginRight: 0, marginLeft: 0, background:"#fff" }}
      >
        <div className="col-md-12 col-sm-12 col-xs-12" style={{background:"#fff"}}>
          <div className="x_panel" style={{ border: 0 }}>
            <div className="x_content">
              <p className="text-center">Drag the slider and choose the right plan for you.</p>
              <div
                className="priceSlideBar text-center"
                style={{
                  width: "90%",
                  margin: "0 auto",
                  padding: "8px 20px 60px 20px",
                }}
              >
                <Slider
                  min={minSize}
                  max={maxSize}
                  marks={this.state.width <= 767 ? emptyIndexes : marks}
                  dotStyle={{display:"inline-block"}}
                  step={null}
                  onChange={this.handleOnChange}
                  value={(marksList || []).indexOf(this.props.subscribePlanInfo.currentValue)}
                />
              </div>
              {this.state.width <= 767 ?
              <p className="text-center" style={{color:"#999", fontSize:18, marginTop: -10}}>
                <strong style={{color:"#52a792"}}>
                  {this.calculateDisplayValue(this.props.subscribePlanInfo.currentValue)}
                </strong> Credits 
                {disc ?  
                (
                <div style={{display:"flex", justifyContent:"center"}}>
                  <span style={{fontSize:14}}>(</span>
                  <p className="text-center"
                  style={{
                    marginTop: 2,
                    color: "#52a792", 
                    fontSize:14
                  }}>
                    {`${disc.toFixed(1)}%`}</p>
                  <p className="text-center"
                  style={{
                    marginTop: 2,
                    color: "#f39c12", 
                    fontSize:14
                  }}>&nbsp;
                    {`Discount Applied`}
                  </p>
                  <span style={{fontSize:14}}>)</span>
                </div>
                  )
                : ""}
              </p> 
              : null}
              {this.state.width <= 767 ? "" :
              <p
                className="text-center"
                style={{
                  color: "#f39c12",
                }}
              >
                More credits = More discounts (%)
              </p>}
              <div className="priceOptions">
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div className="card box-shadow">
                    <div className="card-header">
                      <h3>Subscription</h3>
                      <h4>
                        <strong>{this.calculateDisplayValue(this.props.subscribePlanInfo.currentValue)}</strong> Verifications per day
                      </h4>
                    </div>
                  {ratecards.plans.find(plan => plan.planGroup == "Monthly") ?
                    <div className="card-body">
                      <ul>
                        {ratecards.plans.map((ratecard, index) =>
                          ratecard.IsPersist ? (
                            ""
                          ) : (
                            <li className={"pricing-excerprt"} key={index}>
                              <div className="column-packTitle">
                                {" "}
                                Billed&nbsp;
                                <strong>{ratecard.planGroup}</strong>
                                {ratecard.Discount == 0 ? (
                                  ""
                                ) : (
                                  <small>
                                    {" "}
                                    (You save <strong>{ratecard.Discount}%)</strong>
                                  </small>
                                )}
                              </div>
                              <div className="column-packPrice">
                                <span className="packPrice">
                                  <strong>
                                    ${this.calculateRate(ratecard.DiscountedPrice, ratecard.Freequency)}
                                    /mo
                                  </strong>
                                </span>
                                <a
                                  href="javascript:void(0)"
                                  className="btn btn-primary buttonBorder"
                                  data-page="portfolio"
                                  onClick={this.register}
                                >
                                  <i className="fa fa-shopping-cart" /> Buy
                                </a>
                              </div>
                            </li>
                          )
                        )}
                      </ul>
                    </div> :
                        <div className="card-body" style={{padding:25}}>
                        <div style={{display:"flex", justifyContent:"space-between"}}>
                          <div>
                          {/* <a href="https://cleanyourlists.com/request-enterprise-quote/" target="_blank" style={{    color: "#2f6bc6",
                                  fontSize: 16,
                                  letterSpacing: 0,
                                  cursor: "pointer"
                                  }}>{`Request Quote ›`}</a> */}
                          </div>
                          <div className="pricing-contact">
                          <a target="_blank" href="https://www.mirabeltechnologies.com/contact/" style={{
                                  fontSize: 16,
                                  letterSpacing: 0,
                                  cursor: "pointer"
                                  }}>{`Contact Us`}</a>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div className="card box-shadow">
                    <div className="card-header">
                      <h3>One Time</h3>
                      <h4>
                        <strong>{this.calculateDisplayValue(this.props.subscribePlanInfo.currentValue)}</strong> Verifications
                      </h4>
                    </div>
                    <div className="card-body">
                      <ul>
                        {ratecards.plans.map((ratecard, index) =>
                          ratecard.IsPersist ? (
                            <li className={"pricing-excerprt"} key={index}>
                              <div class="column-packTitle">
                                Billed&nbsp;<strong>Once</strong>{" "}
                              </div>
                              <div class="column-packPrice">
                                <span class="packPrice">
                                  <strong>
                                    $
                                    {
                                      // numberWithCommas(ratecard.DiscountedPrice)
                                      numberWithCommas(parseFloat(ratecard.DiscountedPrice).toFixed(2))
                                    }
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  </strong>
                                </span>
                                <a
                                  href="javascript:void(0)"
                                  className="btn btn-primary buttonBorder"
                                  data-page="portfolio"
                                  onClick={this.register}
                                >
                                  <i className="fa fa-shopping-cart" /> Buy
                                </a>
                              </div>
                            </li>
                          ) : (
                            ""
                          )
                        )}
                      </ul>
                    </div>
                  </div>
                  <small className="body-cover">
                    <br />
                    1 Verification = Valid or Invalid or Unknown Scored email
                    <br />* No credit deduction for Unknown emails
                  </small>
                </div>
                <div className={this.state.width <= 767 ? "col-lg-6 col-md-6 col-sm-6 col-xs-12" : "col-lg-6 col-md-6 col-sm-6 col-md-offset-3"}>
                  <div className="card box-shadow">
                    <div className="card-header">
                      <h3>Enterprise</h3>
                      <h4>
                        <strong>1 Million+ </strong> Verifications
                      </h4>
                    </div>
                    <div className="card-body" style={{padding:25}}>
                      <div style={{display:"flex", justifyContent:"space-between"}}>
                        <div>
                        <a href="https://cleanyourlists.com/request-enterprise-quote/" target="_blank" style={{    color: "#2f6bc6",
                                fontSize: 16,
                                letterSpacing: 0,
                                cursor: "pointer"
                                }}>{`Request Quote ›`}</a>
                        </div>
                        <div className="pricing-contact">
                        <a target="_blank" href="https://www.mirabeltechnologies.com/contact/" style={{
                                fontSize: 16,
                                letterSpacing: 0,
                                cursor: "pointer"
                                }}>{`Contact Us`}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(SubscriptionPlansPreLogin);



// WEBPACK FOOTER //
// ./src/components/Pricing/PricingContainer/SubscriptionPlansPreLogin.js